import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import { Nullable, UserWithToken, WithData } from './api.types';

/**
 * `facing`: enfrentado, la mitad del rival rotada 180°. `side-by-side`: las dos
 * columnas al derecho, para quien lleva los LP de los dos desde un solo lado.
 * `keypad`: sólo las dos vidas; tocar una abre un teclado de calculadora. Es
 * el único que también rige apaisado.
 */
export type LPCalculatorLayout = 'facing' | 'side-by-side' | 'keypad';

export type LPButtonsConfig = {
  extraValues: number[];
  /** Ausente en las configs guardadas antes de que existiera el selector. */
  layout?: LPCalculatorLayout;
};

type LPButtonsSetting = {
  id: number;
  userId: number;
  key: string;
  value: LPButtonsConfig;
  createdAt: string;
  updatedAt: string;
};

const LP_BUTTONS_KEY = 'lp-buttons';

export const getConfig = async (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<WithData<LPButtonsSetting | null>>(
    gql`
      query userSetting($key: String!) {
        data: userSetting(key: $key) {
          id
          userId
          key
          value
          createdAt
          updatedAt
        }
      }
    `,
    { key: LP_BUTTONS_KEY }
  );

export const saveConfig = async (
  user: Nullable<UserWithToken>,
  config: LPButtonsConfig
) =>
  getGraphQLQueryClient(user).request<WithData<LPButtonsSetting>>(
    gql`
      mutation saveUserSetting($key: String!, $value: JSON!) {
        data: saveUserSetting(key: $key, value: $value) {
          id
          userId
          key
          value
          createdAt
          updatedAt
        }
      }
    `,
    { key: LP_BUTTONS_KEY, value: config }
  );
